"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveFile = exports.actsToKML = exports.actsToGPX = exports.actsToGeoJSON = void 0;
const tokml_1 = require("@placemarkio/tokml");
// @ts-ignore
const togpx_1 = __importDefault(require("togpx"));
require("./Act");
function actToGeoJSONFeature(act) {
    if (!act.latLngs) {
        return undefined;
    }
    return {
        type: "Feature",
        geometry: {
            type: "LineString",
            coordinates: act.latLngs.map(([lat, lng]) => [lng, lat]),
        },
        properties: {
            id: act.data.id,
            name: act.data.name,
            type: act.data.type,
            startDate: act.startDate.toISOString(),
            distance: act.data.distance,
            movingTime: act.data.moving_time,
            totalElevationGain: act.data.total_elevation_gain,
        },
    };
}
function actsToGeoJSON(acts) {
    return {
        type: "FeatureCollection",
        features: compact(acts.map(actToGeoJSONFeature)),
    };
}
exports.actsToGeoJSON = actsToGeoJSON;
function actsToGPX(acts) {
    return (0, togpx_1.default)(actsToGeoJSON(acts));
}
exports.actsToGPX = actsToGPX;
function actsToKML(acts) {
    return (0, tokml_1.toKML)(actsToGeoJSON(acts));
}
exports.actsToKML = actsToKML;
function saveFile(contents, fileName) {
    let dummyLink = document.createElement("a");
    dummyLink.href = URL.createObjectURL(contents);
    dummyLink.download = fileName;
    dummyLink.click();
    URL.revokeObjectURL(dummyLink.href);
}
exports.saveFile = saveFile;
function compact(arr) {
    return arr.filter((x) => x !== undefined);
}
